import React from 'react';
import '../Styles/styles.css';

const DocAssist = () => {
    return (
        <section className="container">
            <div className="section-title">
                <h2 >Doc Assist</h2>
            </div>
            <div className="text-center">
                <p className="text-muted">For Gynaecologists and Obstetricians</p>
            </div>
            {/* Client Section */}
            <div className="card my-3">
                <div className="card-header fw-bold">CLIENT</div>
                <div className="card-body">
                    Indira Clinic - Dr. Nandini Devi: One of Bangalore's leading gynecologists
                </div>
            </div>

            {/* Requirement Section */}
            <div className="card my-3">
                <div className="card-header fw-bold">REQUIREMENT</div>
                <div className="card-body">
                    The objective was to develop software designed to help a doctor improve the quality and amount of time spent
                    interacting with the patient and reduce the amount of time devoted to physically writing case histories, prescriptions,
                    and other related information.
                </div>
            </div>

            {/* Solution Section */}
            <div className="card my-3">
                <div className="card-header fw-bold">SOLUTION</div>
                <div className="card-body">
                    MMCS worked with the doctor to develop Doc Assist over a period of 24 months. The various modules developed addressed
                    different aspects of medical practice such as patient administration, billing, and most importantly, modules that enabled
                    the doctor to create a patient's medical file using templates. This allows the doctor to interact with the patient better
                    and provide better care because the doctor no longer spends most of the time physically writing the patient file. Modules
                    were developed to allow the doctor to create files for obstetrics, gynecology, general medicine, and many more.
                </div>
            </div>

            {/* Gains Section */}
            <div className="card my-3">
                <div className="card-header fw-bold">GAINS</div>
                <div className="card-body">
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item">Instant access to over 2500 patient files</li>
                        <li className="list-group-item">Patient files comprise old paper-based records, audio, and video</li>
                        <li className="list-group-item">Ability to research patient database on various criteria</li>
                        <li className="list-group-item">A 95% reduction in time spent writing patient histories</li>
                        <li className="list-group-item">Better doctor-patient interaction</li>
                        <li className="list-group-item">Printed prescriptions that eliminate confusion</li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default DocAssist;
